import { z } from "zod";

export const StepRetrySchema = z.object({
  responseBlob: z.string(),
  // The context to continue the chain of steps with, when the chain is open.
  context: z.string().optional(),
});
